<h2 mat-dialog-title>{{ data.mode === 'edit' ? 'Editar objetivo' : 'Nuevo objetivo' }}</h2>
<div mat-dialog-content>
  <form [formGroup]="form" class="objective-form">
    <p class="level-label">{{ data.relatable_type === 'company' ? 'Company Objective' : 'Product Objective' }}</p>
    @if (data.mode === 'create' && data.relatable_type === 'company_product' && (data.available_products?.length ?? 0) > 0) {
      <mat-form-field appearance="fill">
        <mat-label>Producto</mat-label>
        <mat-select formControlName="relatable_id">
          @for (product of data.available_products; track product.id) {
            <mat-option [value]="product.id">{{ product.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <mat-form-field appearance="fill">
      <mat-label>Objetivo</mat-label>
      <input matInput formControlName="title" placeholder="Escribe tu objetivo inspirador aquí..." [readonly]="saving()" />
    </mat-form-field>

    @if (validation(); as result) {
      @if (!result.is_valid) {
        <div class="validation-feedback">
          @if (rejection_reason_label(); as reason_label) {
            <span class="rejection-reason">{{ reason_label }}</span>
          }
          <p class="feedback">{{ result.feedback }}</p>
          @if (result.suggestions.length > 0) {
            <div class="suggestions">
              @for (suggestion of result.suggestions; track suggestion) {
                <button
                  mat-stroked-button
                  type="button"
                  class="suggestion-button"
                  [disabled]="saving()"
                  (click)="applySuggestion(suggestion)"
                >
                  {{ suggestion }}
                </button>
              }
            </div>
          }
        </div>
      }
    }

    <section class="guide-qualities" aria-label="Cualidades de un buen objetivo">
      <p class="guide-qualities-title">Un buen objetivo</p>
      <ul>
        <li>
          <mat-icon>auto_awesome</mat-icon>
          <span>Cualitativo, inspirador y memorable: se puede repetir en una reunión sin mirar la pantalla</span>
        </li>
        <li>
          <mat-icon>flag</mat-icon>
          <span>Describe un destino o cambio de estado que queremos que sea verdad al final del periodo</span>
        </li>
        <li>
          <mat-icon>block</mat-icon>
          <span>Sin cifras, porcentajes ni nombres de métricas (eso va en los Key Results)</span>
        </li>
      </ul>

      <div class="guide-examples">
        <div class="guide-examples-column guide-examples-good">
          <p class="guide-examples-heading">
            <mat-icon>check_circle</mat-icon>
            Ejemplos correctos
          </p>
          <ul>
            <li>«Dominar el mercado retail de café B2B en el South Bay»</li>
            <li>«Lanzar un MVP brutal que enamore a los stakeholders»</li>
            <li>«Transformar los hábitos de uso de cupones en Palo Alto»</li>
          </ul>
        </div>
        <div class="guide-examples-column guide-examples-bad">
          <p class="guide-examples-heading">
            <mat-icon>cancel</mat-icon>
            Ejemplos incorrectos
          </p>
          <ul>
            <li>«Subir las ventas un 30%»</li>
            <li>«Duplicar nuestra base de usuarios»</li>
            <li>«2 millones de ingresos»</li>
          </ul>
        </div>
      </div>
    </section>

    <div class="guide-side-by-side">
      <div class="guide-panel">
        <p class="guide-panel-title">Notas</p>
        <ul>
          <li>
            <span class="guide-notes-label">Time-bound</span>
            El periodo OKR ya acota el tiempo: no hace falta meter fechas ni trimestres en el título.
          </li>
          <li>
            <span class="guide-notes-label">Company vs Product</span>
            El product objective debe ser actionable by the team independently: el equipo del producto puede avanzar sin depender de otros.
            El company objective puede ser más amplio y alinearse entre varios productos.
          </li>
        </ul>
      </div>

      <div class="guide-panel">
        <p class="guide-panel-title">Referencia teórica</p>
        <p class="guide-panel-copy">
          Seguimos a <strong>Christina Wodtke</strong> y su libro
          <a
            href="https://www.amazon.es/Radical-Focus-Achieving-Important-Objectives/dp/0996006087/ref=sr_1_1?crid=31CHAH8S7HLKO&dib=eyJ2IjoiMSJ9.EZMS5-2hzEHGwYUKcrwXWPhrPZenORiAzU0Ll9WNYRXcLPYUcTwI7ctq9PcPgu4xd9ypxqDRm-_TZOuGyPUNaDx7MghBQiLhtQfbmo2SmVKszfW1LEwavxTitIbV4QG8Y0JpqhKY-RQDo6DmWKXgkA._doG1GSrrq1nNnfeU6QRmKIwUD9-9Gh3S9cye2y7_Uo&dib_tag=se&keywords=radical+focus&qid=1787294033&sprefix=radical+fo%2Caps%2C172&sr=8-1"
            target="_blank"
            rel="noopener noreferrer"
            ><em>Radical Focus</em></a
          >: el Objective apunta a un <strong>outcome</strong> (el cambio de resultado que queremos lograr), no a un
          <strong>output</strong> (entregar features o cerrar tareas).
        </p>
        <p class="guide-panel-copy">Así el equipo se alinea en conseguir resultados reales, no solo en completar trabajo.</p>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button type="button" [disabled]="saving()" (click)="close()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="saving()" (click)="save()">
    {{ submit_label() }}
  </button>
</div>
